import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Loader } from 'lucide-react';
import './components/Editor/resizeObserverPatch';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const LoaderComponent = () => (
  <div className="flex items-center justify-center h-screen">
    <Loader className="animate-spin" size={48} />
  </div>
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <React.Suspense fallback={<LoaderComponent />}>
          <App />
        </React.Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
